import Sidebar from '../components/Sidebar';

import './Settings.css';

const Settings = () => {

    return (

        <div className="settings-page">

            <Sidebar />

            <div className="settings-content">

                <h1>Settings</h1>

                <p className="settings-text">
                    Manage dashboard preferences and account settings.
                </p>


                <div className="settings-container">

                    <div className="settings-card">

                        <h2>Profile Settings</h2>

                        <p>
                            Update administrator information and credentials.
                        </p>

                    </div>


                    <div className="settings-card">

                        <h2>Notification Settings</h2>

                        <p>
                            Control email notifications and system alerts.
                        </p>

                    </div>


                    <div className="settings-card">

                        <h2>Security</h2>

                        <p>
                            Manage passwords and dashboard security options.
                        </p>

                    </div>

                </div>

            </div>

        </div>

    );
}

export default Settings;